import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getAuthTeamMember } from 'store/authentication/selectors';
import AxiosService from 'services/AxiosService';
import { markCustomerNotificationsRead } from '@kizen/api/customer-notifications';
import { useQueryClient } from '@tanstack/react-query';
import {
  customerNotificationsIndicatorQuery,
  customerNotificationsInfiniteQuery,
} from 'query/customer-notifications';
import { FROM_NOTIFICATION_KEY } from 'constants/searchParams';
import { DEFAULT_PATHS } from 'routes/paths';
import useSearchParam, { setSearchParams } from 'hooks/useSearchParam';

export const NotificationLinkHandler = () => {
  const qc = useQueryClient();
  const history = useHistory();
  const teamMember = useSelector(getAuthTeamMember);
  const notificationId = useSearchParam(FROM_NOTIFICATION_KEY);

  const onNotificationsPage = history.location.pathname.startsWith(
    DEFAULT_PATHS.NOTIFICATIONS
  );

  if (notificationId && !onNotificationsPage && teamMember) {
    setSearchParams(
      history,
      { [FROM_NOTIFICATION_KEY]: null },
      { method: 'replace' }
    );
  }

  useEffect(() => {
    if (notificationId && teamMember) {
      markCustomerNotificationsRead(AxiosService, {
        notification_ids: [notificationId],
        read: true,
      }).then(
        () => {
          qc.invalidateQueries({
            queryKey: customerNotificationsIndicatorQuery().queryKey,
          });
          qc.invalidateQueries({
            queryKey: customerNotificationsInfiniteQuery().queryKey,
          });
        },
        () => {
          // Ignores error. This is a silent action and we expect 403/404 errors
          // if user logs in to different business or if notification is archived
        }
      );
    }
  }, [notificationId, teamMember, qc]);

  return null;
};
